import styled from 'styled-components';

interface ContainerProps {
  gap?: number;
  alignItems?: 'center' | 'flex-start' | 'flex-end';
  justifyContent?:
    | 'center'
    | 'flex-start'
    | 'flex-end'
    | 'space-between'
    | 'space-around';
  backgroundColor?: string;
  flexWrap?: 'wrap' | 'nowrap' | 'wrap-reverse';
}

export const ViewContainer = styled.div<ContainerProps>`
  display: flex;
  flex-direction: row;
  gap: ${(props) => props.gap ?? 0}px;
  align-items: ${(props) => props.alignItems ?? 'center'};
  justify-content: ${(props) => props.justifyContent ?? 'flex-start'};
  background-color: ${(props) => props.backgroundColor ?? 'transparent'};
  flex-wrap: ${(props) => props.flexWrap ?? 'nowrap'};
`;

export const PressableContainer = styled.button<ContainerProps>`
  display: flex;
  flex-direction: row;
  gap: ${(props) => props.gap ?? 0}px;
  align-items: ${(props) => props.alignItems ?? 'center'};
  justify-content: ${(props) => props.justifyContent ?? 'flex-start'};
  background-color: ${(props) => props.backgroundColor ?? 'transparent'};
  border: none;
  cursor: pointer;
`;
